import {
  Box,
  Flex,
  Image,
  ListItem,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  UnorderedList,
} from "@chakra-ui/react";
import { useState } from "react";

import { InfoPopover } from "../../components/InfoPopover";
import {
  EnergyDisplay,
  energyValueDescriptors,
} from "../../elements/EnergyDisplay";
import { useComparePageContext } from "../../shared/state/ComparePageContext";

export function CompareEnergyTable() {
  const { scenarios, situation } = useComparePageContext();
  const [open, setOpen] = useState(true);

  return (
    <Table
      className={open ? "open" : "closed"}
      sx={{ borderSpacing: "2rem 0" }}
      variant="compare"
    >
      <Thead>
        <Tr>
          <Th onClick={() => setOpen(!open)}>
            <Flex>
              <Image
                h={4}
                mr={2}
                src="/svg/chevron.svg"
                transform={open ? "rotate(180deg)" : "rotate(0deg)"}
                transition="transform 0.2s"
                w={4}
              />
              Energie
            </Flex>
          </Th>
          <Th>Energie</Th>
          {scenarios?.map((scenario) => (
            <Th key={scenario.id}>Energie</Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>
            <Box display="flex">
              {energyValueDescriptors.co2Emission.title}{" "}
              <Text color="brand.gray.120" fontSize={14} ml={2} w="min-content">
                {energyValueDescriptors.co2Emission.unit}
              </Text>
            </Box>
          </Td>
          <Td>
            <EnergyDisplay
              baseValue={situation.calculation.yearlyCO2Emission}
              dataKey="co2Emission"
            />
          </Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id}>
              <EnergyDisplay
                baseValue={situation.calculation.yearlyCO2Emission}
                currentValue={scenario.calculation.yearlyCO2Emission}
                dataKey="co2Emission"
              />
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <Box display="flex">
              {energyValueDescriptors.electricityConsumption.title}{" "}
              <Text color="brand.gray.120" fontSize={14} ml={2} w="min-content">
                {energyValueDescriptors.electricityConsumption.unit}
              </Text>
            </Box>
          </Td>
          <Td>
            <EnergyDisplay
              baseValue={situation.calculation.yearlyElectricityConsumption}
              dataKey="electricityConsumption"
              info={
                <InfoPopover size="2xs">
                  <UnorderedList>
                    {!!situation.calculation
                      .buildingRelatedElectricityConsumption && (
                      <ListItem>
                        Gebouwgebonden elektra verbruik:{" "}
                        {
                          situation.calculation
                            .buildingRelatedElectricityConsumption
                        }{" "}
                        kWh/jaar
                      </ListItem>
                    )}
                    {!!situation.calculation
                      .householdElectricityConsumption && (
                      <ListItem>
                        Huishuidelijk elektra verbruik:{" "}
                        {situation.calculation.householdElectricityConsumption}{" "}
                        kWh/jaar
                      </ListItem>
                    )}
                    {!!situation.calculation.sustainableEnergyGeneration && (
                      <ListItem>
                        Duurzame energie opwekking:{" "}
                        {situation.calculation.sustainableEnergyGeneration}{" "}
                        kWh/jaar
                      </ListItem>
                    )}
                  </UnorderedList>
                </InfoPopover>
              }
            />
          </Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id}>
              <EnergyDisplay
                baseValue={situation.calculation.yearlyElectricityConsumption}
                currentValue={scenario.calculation.yearlyElectricityConsumption}
                dataKey="electricityConsumption"
                info={
                  <InfoPopover size="2xs">
                    <UnorderedList>
                      {!!scenario.calculation
                        .buildingRelatedElectricityConsumption && (
                        <ListItem>
                          Gebouwgebonden elektra verbruik:{" "}
                          {
                            scenario.calculation
                              .buildingRelatedElectricityConsumption
                          }{" "}
                          kWh/jaar
                        </ListItem>
                      )}
                      {!!scenario.calculation
                        .householdElectricityConsumption && (
                        <ListItem>
                          Huishuidelijk elektra verbruik:{" "}
                          {scenario.calculation.householdElectricityConsumption}{" "}
                          kWh/jaar
                        </ListItem>
                      )}
                      {!!scenario.calculation.sustainableEnergyGeneration && (
                        <ListItem>
                          Duurzame energie opwekking:{" "}
                          {scenario.calculation.sustainableEnergyGeneration}{" "}
                          kWh/jaar
                        </ListItem>
                      )}
                    </UnorderedList>
                  </InfoPopover>
                }
              />
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <Box display="flex">
              {energyValueDescriptors.gasConsumption.title}{" "}
              <Text color="brand.gray.120" fontSize={14} ml={2} w="min-content">
                {energyValueDescriptors.gasConsumption.unit}
              </Text>
            </Box>
          </Td>
          <Td>
            <EnergyDisplay
              baseValue={situation.calculation.yearlyGasConsumption}
              dataKey="gasConsumption"
            />
          </Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id}>
              <EnergyDisplay
                baseValue={situation.calculation.yearlyGasConsumption}
                currentValue={scenario.calculation.yearlyGasConsumption}
                dataKey="gasConsumption"
              />
            </Td>
          ))}
        </Tr>
      </Tbody>
    </Table>
  );
}
